import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { getAnalyticsInstance } from "./analyticsLoader";

export const useFirebasePageView = () => {
  const location = useLocation();

  useEffect(() => {
    const analytics = getAnalyticsInstance();
    if (!analytics) return;

    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);
};